import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router/index'
import { user } from './index'
import global_config from '@/global_config'

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? global_config.baseURL : global_config.serverURL
axios.defaults.withCredentials = true
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers['token'] = user.token || ''
axios.defaults.headers.post['Content-Type'] = 'application/json'

function checkRequestConfig(config) {
	if (config.method === 'post' && config.url === user.request.url && user.request.params && user.requestNum === 0) {
		config.data = user.request.params;
		config.resetData = true;
	}
}

function copyRequestData(requestData) {
	let data = Object.assign({}, requestData);
	if (data.sizeCached) data.sizeCached = false;
	if (data.cached) data.cached = false;
	return data;
}

axios.repaireRequestParam = function (res, data) {
	if (res.search_data && data.search_data) {
		for (let k in data.search_data) {
			if (res.search_data[k] !== undefined) data.search_data[k] = res.search_data[k];
		}
	}
}

// 请求拦截器，内部根据返回值，重新组装，统一管理。
axios.interceptors.request.use(config => {
	checkRequestConfig(config);
	++user.requestNum;
	console.log('request:', Date.now(), config.url, config.data, user.requestNum);
	if (config.data && config.data.page && config.data.page_size) {
		if (!window.requestMap) window.requestMap = {};
		if (window.isBack) {
			if (window.requestMap[config.url]) config.data = window.requestMap[config.url];
			window.isBack = false;
		}

		let data = copyRequestData(config.data);
		window.requestMap[config.url] = data;
	}
	return config;
});

axios.interceptors.response.use(res => {
	console.log('response:', Date.now(), res.config.url, res.data);
	if (typeof res.data !== 'object') {
		ElMessage.error('服务端异常！')
		return Promise.reject(res);
	}
	if (res.data.resultCode && res.data.resultCode != 200) {
		if (res.data.message) ElMessage.error(res.data.message);
		if (res.data.resultCode == 419) {
			router.push({ path: '/login' });
		}
		return Promise.reject(res.data);
	}
	if (res.data && res.data.err) {
		alert(res.data.msg);
		if (res.data.err === 1001 || res.data.err === 1002) {
			user.saveToken('', axios, true);
		}
	} else {
		let data = res.config.data ? copyRequestData(JSON.parse(res.config.data)) : {};
		user.saveRequest(res.config.url, JSON.stringify(data));
		if (res.config.resetData) {
			res.data.search_data = data;
		}
	}

	return Promise.resolve(res.data);
});

export default axios